export default __webpack_public_path__ + "e7ac3b4c7ee721fbac555ab73ac53443.svg";